module.exports = __webpack_public_path__ + "static/media/jan-hanzelka-photo.0728da90.jpg";